<div class="holdings-list">
  <ng-container *ngIf="funds.length > 0">
    <a *ngFor="let fund of funds" class="unstyled terra-card-hover-effect" matRipple
      [routerLink]="moreDetails(fund.id, fund.opportunityCode, false, fund.isMarketingDeckWasSent && !fund.cameByOpportunity)"
      [queryParams]="getMoreDetailsQueryParams(fund.isMarketingDeckWasSent && !fund.cameByOpportunity) | async">
      <terra-lp-holding-card [holding]="fund" [isOpportunity]="isOpportunity"></terra-lp-holding-card>
    </a>
  </ng-container>

  <ng-container *ngIf="assets.length > 0">
    <a *ngFor="let asset of assets" class="unstyled terra-card-hover-effect" matRipple
      [routerLink]="moreDetails(asset.id, asset.opportunityCode, true, asset.isMarketingDeckWasSent && !asset.cameByOpportunity)"
      [queryParams]="getMoreDetailsQueryParams(asset.isMarketingDeckWasSent && !asset.cameByOpportunity) | async">
      <terra-lp-holding-card [holding]="asset" [isOpportunity]="isOpportunity"></terra-lp-holding-card>
    </a>
  </ng-container>

  <!--  <terra-add-your-asset-card *ngIf="showAddYourAssetCard" class="terra-card-hover-effect"></terra-add-your-asset-card>-->
</div>